import{k as getSlideTransformEl}from"./utils.min.mjs";function effectTarget(e,i){const t=getSlideTransformEl(i);return t!==i&&(t.style.backfaceVisibility="hidden",t.style["-webkit-backface-visibility"]="hidden"),t}export{effectTarget as e};
//# sourceMappingURL=effect-target.mjs.map


//////////////////
// WEBPACK FOOTER
// ./~/swiper/shared/effect-target.min.mjs
// module id = 145
// module chunks = 0